import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import brand from "@/config/brand";

const LegalShell = ({ eyebrow, title, effectiveDate, children, testId }) => (
  <div className="min-h-screen bg-surface-50 text-ink-900">
    <Header />
    <main data-testid={testId}>
      <section className="border-b border-surface-200 bg-white">
        <div className="mx-auto max-w-3xl px-6 pt-10 pb-8 lg:px-8 lg:pt-14 lg:pb-10">
          <p className="text-xs font-medium uppercase tracking-widest text-intel-800">
            {eyebrow}
          </p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-ink-900 sm:text-4xl">
            {title}
          </h1>
          <p className="mt-3 text-sm text-ink-500">
            تاريخ السريان: <span dir="ltr" className="font-mono">{effectiveDate}</span>
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-6 py-10 lg:px-8 lg:py-14">
        <div className="prose-fursa space-y-6 text-[15px] leading-relaxed text-ink-800">
          {children}
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default function PrivacyPage() {
  return (
    <LegalShell
      eyebrow="Privacy"
      title="سياسة الخصوصية"
      effectiveDate={brand.legal.privacyEffectiveDate}
      testId="privacy-page"
    >
      <p>
        نحن في {brand.name} نُقدِّر خصوصيتك ونلتزم بحماية بياناتك. توضِّح هذه السياسة كيف نجمع
        المعلومات ونستخدمها ونحميها عند تصفُّحك للمنصة أو التسجيل فيها.
      </p>
      <h2 className="text-lg font-semibold text-ink-900">البيانات التي نجمعها</h2>
      <p>
        نجمع الحدَّ الأدنى من البيانات اللازمة لتشغيل الخدمة: البريد الإلكتروني عند التسجيل،
        التفضيلات الخاصة بالقطاعات والدول التي تختارها، والفرص التي تحفظها للرجوع إليها لاحقاً.
        لا نجمع بيانات مالية ولا أرقام هويات ولا أي بيانات حسّاسة.
      </p>
      <h2 className="text-lg font-semibold text-ink-900">كيف نستخدم البيانات</h2>
      <p>
        نستخدم بياناتك حصراً لتخصيص تجربتك داخل المنصة (عرض الفرص الأكثر ملاءمة لاهتماماتك)
        ولإرسال إشعارات المنتج عند تفعيلها. لا نبيع بياناتك ولا نُشاركها مع أطراف ثالثة لأغراض تسويقية.
      </p>
      <h2 className="text-lg font-semibold text-ink-900">حقّك في حذف بياناتك</h2>
      <p>
        يمكنك طلب حذف حسابك وكل بياناتك المرتبطة به في أي وقت عبر مراسلة{" "}
        <a href={`mailto:${brand.contact.email}`} className="font-medium text-intel-800 underline">
          {brand.contact.email}
        </a>
        . سنُنجز الطلب خلال 30 يوم عمل.
      </p>
      <h2 className="text-lg font-semibold text-ink-900">التحديثات</h2>
      <p>
        قد نُحدِّث هذه السياسة من حين لآخر. تاريخ السريان أعلاه يعكس آخر تحديث. الاستخدام
        المستمر للمنصة بعد التحديث يُعتبر موافقة على النسخة الجديدة.
      </p>
    </LegalShell>
  );
}
